import { ObjectId } from "bson";

export interface Dict<T = any> {
    [key: string]: T;
}

export type NullToUndefined<T> = T extends null ? undefined : T;
export type UndefinedToNull<T> = T extends undefined ? null : T;
export type Nullable<T> = { [P in keyof T]-?: UndefinedToNull<T[P]> | null };

export type Marshalled<T> = T extends Date | ObjectId
    ? string
    : T extends object
    ? { [P in keyof T]-?: Marshalled<T[P]> }
    : T extends any[]
    ? Array<Marshalled<T[number]>>
    : NullToUndefined<T>;

export type Unmarshalled<T> = T extends Date | ObjectId
    ? T
    : T extends object
    ? { [P in keyof T]-?: Unmarshalled<T[P]> }
    : T extends any[]
    ? Array<Unmarshalled<T[number]>>
    : UndefinedToNull<T>;

export type DeepOptional<T> = Partial<
    T extends object
        ? { [P in keyof T]: DeepOptional<T[P]> }
        : T extends any[]
        ? Array<DeepOptional<T[number]>>
        : T | undefined | null
>;

export type ToJson<T> = T extends Date | ObjectId
    ? string
    : T extends object
    ? { [P in keyof T]: ToJson<T[P]> }
    : T extends any[]
    ? Array<ToJson<T[number]>>
    : T;

export enum YesNo {
    No = "no",
    Yes = "yes",
}
